<div class="hw-box-content"> 
    <div class="hw-header-wrap">
        <div class="row">
            <div class="col-2">
                <i class="fn-global-site"></i>
                App Instance Live Status Report
            </div>           
        </div>
    </div>
     <div class="hw-title">
        <div class="row">
             <div class="col-2">
            <fn-select
              [labelKey]="'primaryKey'"
              [inputKey]="'primaryKey'"
              [optionList]="instanceArray"
              [placeholder]="'Select HostName'"
              [(ngModel)]="selectAppName"
              [ngModelOptions]="{ standalone: true }"
            ></fn-select>
            </div>
            <div class="col-1">
                <fn-button *ngIf="!showData" [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'Filter'"
                    (click)="filterAction()"></fn-button>
            </div>
             <div class="col-2">
            <fn-select
              [labelKey]="'primaryKey'"
              [inputKey]="'primaryKey'"
              [optionList]="instanceArray"
              [placeholder]="'Select HostName'"
              [(ngModel)]="selectAppName"
              [ngModelOptions]="{ standalone: true }"
            ></fn-select>
            </div>
            <div class="col-2">
                <fn-button [type]="'success'" [btnClass]="'fn-global-download'" [text]="'Download'"
                    (click)="filterAction()"></fn-button>
            </div>
            <div class="col-2 text-right">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'Not-tested In Last 20 min'"
                    (click)="filterAction()"></fn-button>
            </div>
             <div class="col-1 text-right">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'Dead Instance'"
                    (click)="filterAction()"></fn-button>
            </div>            
            <div class="col-1 text-right">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'Not Configured'"
                    (click)="filterAction()"></fn-button>
            </div>
            <div class="col-1 fw-bold fs-5">Count : {{ count }}</div>
        </div>
    </div>
    <div class="hw-content">
        <div class="row">
            <div class="col-12" *ngIf="!showData">
                @if (uiMap.isDataLoaded) {
                <!-- <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='mqDataArray'
                   [pageSize]="15" (updateRow)="updateRowAction($event)" (deleteRow)="deleteRowAction($event)"></fn-table> -->
                }
            </div>
        </div>
    </div>
</div>
